<script setup>
defineProps({
  id: {
    type: String,
    required: false,
    default: 'date-input',
  },
  max: {
    type: String,
    required: false,
    default: '',
  },
  min: {
    type: String,
    required: false,
    default: '',
  },
  inputClass: {
    type: String,
    required: false,
    default: '',
  },
  labelClass: {
    type: String,
    required: false,
    default: '',
  },
  datePlaceholder: {
    type: String,
    required: false,
    default: 'YYYY-MM-DD',
  },
})
function todayOrAfter(value) {
  return moment(value, 'YYYY-MM-DD').isSameOrAfter(moment().startOf('day'))
}
function livingBirthday(value) {
  const date = moment(value, 'YYYY-MM-DD')
  const oneHundredTwentyYearsAgo = moment().subtract(120, 'years')
  return oneHundredTwentyYearsAgo.isBefore(date)
}
function legalBirthday(value) {
  const date = moment(value, 'YYYY-MM-DD')
  const twentyOneYearsAgo = moment().subtract(21, 'years')
  return twentyOneYearsAgo.isAfter(date)
}
</script>

<template>
  <FormKit
    :id="id"
    type="date"
    :placeholder="datePlaceholder"
    class="no-calendar"
    :validation-messages="{
      date: `Error: Not a valid date, please use the format ${datePlaceholder}`,
      todayOrAfter: 'Error: Date must be today or later.',
      livingBirthday: 'Error: Date must be within the last 120 years',
      legalBirthday: 'Error: You must be at least 21 years old.',
    }"
    :validation-rules="{
      todayOrAfter: ({ value }) => todayOrAfter(value),
      livingBirthday: ({ value }) => livingBirthday(value),
      legalBirthday: ({ value }) => legalBirthday(value),
    }"
    v-bind="$attrs"
    :max="max"
    :min="min"
    :input-class="inputClass"
    :label-class="labelClass"
  />
</template>
